export const GUIDE_REQUEST_STATES = Object.freeze({
  REQUESTED: "requested",
  GUIDE_ASSIGNED: "guide_assigned",
  PROPOSAL_DRAFT: "proposal_draft",
  AWAITING_CUSTOMER: "awaiting_customer",
  CHANGES_REQUESTED: "changes_requested",
  CUSTOMER_ACCEPTED: "customer_accepted",
  PAYMENT_PENDING: "payment_pending",
  PAID: "paid",
  CONFIRMED_PRIVATE: "confirmed_private",
  COMPLETED: "completed",
  REJECTED: "rejected",
  CANCELLED: "cancelled",
  EXPIRED: "expired",
  PAYMENT_FAILED: "payment_failed",
});

const TRANSITIONS = Object.freeze({
  requested: ["guide_assigned", "rejected", "cancelled", "expired"],
  guide_assigned: ["proposal_draft", "awaiting_customer", "rejected", "cancelled"],
  proposal_draft: ["awaiting_customer", "cancelled"],
  awaiting_customer: ["customer_accepted", "changes_requested", "rejected", "expired"],
  changes_requested: ["proposal_draft", "awaiting_customer", "cancelled"],
  customer_accepted: ["payment_pending", "confirmed_private", "cancelled"],
  payment_pending: ["paid", "payment_failed", "cancelled"],
  payment_failed: ["payment_pending", "cancelled"],
  paid: ["confirmed_private"],
  confirmed_private: ["completed", "cancelled"],
  completed: [],
  rejected: [],
  cancelled: [],
  expired: [],
});

export function normalizeGuideRequestState(value, request = null) {
  const state = String(value || "").trim().toLowerCase();
  if (TRANSITIONS[state]) return state;
  if (state === "pending") return GUIDE_REQUEST_STATES.REQUESTED;
  if (state === "accepted") {
    const payment = String(request?.paymentStatus || request?.payment?.status || "").toLowerCase();
    if (payment === "paid") return GUIDE_REQUEST_STATES.CONFIRMED_PRIVATE;
    return GUIDE_REQUEST_STATES.AWAITING_CUSTOMER;
  }
  if (state === "rejected") return GUIDE_REQUEST_STATES.REJECTED;
  return GUIDE_REQUEST_STATES.REQUESTED;
}

export function canTransitionGuideRequest(from, to) {
  const current = normalizeGuideRequestState(from);
  const next = normalizeGuideRequestState(to);
  return (TRANSITIONS[current] || []).includes(next);
}

export function isGuideRequestTerminal(value) {
  const state = normalizeGuideRequestState(value);
  return ["completed", "rejected", "cancelled", "expired"].includes(state);
}

export const GUIDE_REQUEST_STATE_LABELS = Object.freeze({
  requested: "Pedido enviado",
  guide_assigned: "Pedido aceite — proposta em preparação",
  proposal_draft: "Proposta em preparação",
  awaiting_customer: "A aguardar decisão do cliente",
  changes_requested: "Alterações pedidas",
  customer_accepted: "Proposta aceite pelo cliente",
  payment_pending: "Pagamento pendente",
  payment_failed: "Pagamento não concluído",
  paid: "Pagamento confirmado",
  confirmed_private: "Evento privado confirmado",
  completed: "Concluído",
  rejected: "Proposta rejeitada",
  cancelled: "Cancelado",
  expired: "Expirado",
});
